import {loyaltyQuestConst} from '../constants/actionConstants'
import {objPendingErrorFalse} from '../constants/variableConstant'

const initState = {
    listQuest: {obj: []},
    questActivity: {obj: []},
    questDetail: {obj: []},
    pending: false,
    error: false
}

export default (state = initState, action) => {
    switch (action.type) {
        case loyaltyQuestConst.LOYALTY_QUEST_GET_ALL:
            return {
                ...state,
                ...objPendingErrorFalse,
                listQuest: action.response
            }
        case loyaltyQuestConst.LOYALTY_QUEST_GET_BY_ACTIVITY:
            return {
                ...state,
                ...objPendingErrorFalse,
                questActivity: action.response
            }
        case loyaltyQuestConst.LOYALTY_QUEST_GET_DETAIL:
            return {
                ...state,
                ...objPendingErrorFalse,
                questDetail: action.response
            }
        case loyaltyQuestConst.LOYALTY_QUEST_PENDING:
            return {
                ...state,
                pending: action.response
            }
        case loyaltyQuestConst.LOYALTY_QUEST_ERROR:
            return {
                ...initState,
                error: action.response
            }

        default:
            return state
    }
}